import { ISurveyTemplateElementData } from './ISurveyTemplateElementData';
import { ISurveyTemplateElementGroupData } from './ISurveyTemplateElementGroupData';
import { ISurveyTemplateManifestationData } from './ISurveyTemplateManifestationData';
import { ISurveyTemplateUnitData } from './ISurveyTemplateUnitData';

export function isSurveyTemplateUnitData(
    data: ISurveyTemplateUnitData | ISurveyTemplateElementGroupData | ISurveyTemplateElementData | ISurveyTemplateManifestationData,
): data is ISurveyTemplateUnitData {
    return (data as ISurveyTemplateUnitData).unitId !== undefined;
}
